import React from "react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies, ReactCookieProps } from "react-cookie";

import "./cookie-banner.scss";
import {MapViewerConfiguration} from "../../../config/map-viewer-configuration";

export interface CookieBannerProps extends ReactCookieProps {
    mapViewerConfig: MapViewerConfiguration;
    className?: string;
}

class CookieBanner extends React.Component<CookieBannerProps, any> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    state = { visible: true};
    constructor(props: CookieBannerProps) {
        super(props);
        const { cookies } = this.props;
        this.state = {
            visible: !cookies?.get("Cookie.Overlay.Accepted")
        };
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = (accepted: boolean): void => {
        const { cookies } = this.props;
        this.setState({ visible: false });
        if (cookies) {
            cookies.set("Cookie.Overlay.Accepted", accepted ? "True" : "False",
                {path: "/", sameSite: "lax", maxAge: (365 * 24 * 60 * 60),
                    domain: (window.location.hostname.indexOf(".lu.ch") > 0)? ".lu.ch": window.location.hostname});
        }
    };

    render(): JSX.Element | null {
        const { mapViewerConfig } = this.props;
        if (this.state.visible) {
            let className = "cookieoverlay geo-component";
            if (this.props.className) {
                className += " " + this.props.className;
            }
            return (
                <div className={className}>
                    <div id="cookieOverlay" className="cookieoverlay__content gridrow">
                        <div className="large-10 gridcolumns">
                            Auf dieser Webseite werden zur Verbesserung der Funktionalität und des Leistungsverhaltens
                            Cookies eingesetzt. Durch Klicken auf den OK-Button stimmen Sie der Verwendung von Cookies
                            auf dieser Webseite zu.<br/>
                            <a href={mapViewerConfig.urls?.disclaimer} className={"cookieoverlay__content-link-item"}
                                target={"_blank"} rel={"noreferrer"}>Weitere Informationen</a>
                        </div>
                        <div className="large-2 gridcolumns">
                            <button type="button" name="btnCookieOverlay" value="OK" id="btnCookieOverlay"
                                className="cookieoverlay__content-submit-item"
                                onClick={() => this.handleDismiss(true)}>OK
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }
}
export default withCookies(CookieBanner);
